import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SottoProgettoForm = _resolveComponent("SottoProgettoForm")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    visible: _ctx.visible,
    backdrop: ""
  }, {
    main: _withCtx(() => [
      _createVNode(_component_SottoProgettoForm, {
        onSaved: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('saved', $event))),
        defaultValue: _ctx.defaultValue,
        onChiudi: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('chiudi'))),
        id: _ctx.id,
        progetto_id: _ctx.progetto_id,
        progetto_is_promo: _ctx.progetto_is_promo,
        create: _ctx.create,
        cliente_id: _ctx.cliente_id
      }, null, 8, ["defaultValue", "id", "progetto_id", "progetto_is_promo", "create", "cliente_id"])
    ]),
    _: 1
  }, 8, ["visible"]))
}